import _ from "lodash";

export const customerFilters = {
  partialCustomerName: {},
  assignedTo: {
    key: "representativeKey",
    value: "representativeValue"
  },
  product: {
    key: "productFamilyKey",
    value: "productFamilyValue"
  },
  mill: {
    key: "millKey",
    value: "millValue"
  },
  customerType: {
    key: "customerTypeKey",
    value: "customerTypeValue"
  }
};

export const getGroupedFiltersValues = (customerSelections, fieldName, groupByKeyName) => {
  const fieldInfo = customerFilters[fieldName];
  const orderedSelections = _.orderBy(customerSelections, selection => selection[fieldInfo.value]);
  const uniqueSelections = _.uniqBy(orderedSelections, selection => selection[fieldInfo.key]);
  const groupedCustomerSelections = _.groupBy(uniqueSelections, groupByKeyName);

  return Object.keys(groupedCustomerSelections).map(keyName => ({
    label: keyName,
    options: groupedCustomerSelections[keyName].map(uniqueSelection => ({
      label: uniqueSelection[fieldInfo.value],
      value: uniqueSelection[fieldInfo.key]
    }))
  }));
};

export const getFiltersValues = (customerSelections, fieldName) => {
  const fieldInfo = customerFilters[fieldName];
  const orderedSelections = _.orderBy(customerSelections, selection => selection[fieldInfo.value]);
  const uniqueValues = _.uniqBy(orderedSelections, selection => selection[fieldInfo.key]);

  return uniqueValues.map(uniqueSelection => ({
    label: uniqueSelection[fieldInfo.value],
    value: uniqueSelection[fieldInfo.key]
  }));
};

export const getFilterValue = (customerSelections, fieldName, value) => {
  const fieldInfo = customerFilters[fieldName];
  const firstValue = customerSelections.find(selection => selection[fieldInfo.key] === value) || {};

  return {
    label: firstValue[fieldInfo.value],
    value: firstValue[fieldInfo.key]
  };
};

export const filterCustomerList = (customers, filters) => {
  if (!filters) {
    return customers;
  }

  const nonEmptyFilters = Object.keys(filters).filter(filter => !_.isEmpty(filters[filter]));

  if (_.isEmpty(nonEmptyFilters)) {
    return customers;
  }

  const filteredCustomers = customers.filter(customer => {
    const { customerSelection = [] } = customer;

    return _.find(customerSelection, selection => {
      return _.every(nonEmptyFilters, nonEmptyFilter => {
        if (nonEmptyFilter === "partialCustomerName") {
          return _.includes(customer.customerName.toLowerCase(), filters[nonEmptyFilter].toLowerCase());
        }

        const filterInfo = customerFilters[nonEmptyFilter];
        return filters[nonEmptyFilter].includes(selection[filterInfo.key]);
      });
    });
  });

  return filteredCustomers;
};



// WEBPACK FOOTER //
// ./src/components/Customer/Filters/FilterHelpers.js